var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 28.375C29.7802 28.375 33.25 24.9052 33.25 20.625C33.25 16.3448 29.7802 12.875 25.5 12.875C21.2198 12.875 17.75 16.3448 17.75 20.625C17.75 24.9052 21.2198 28.375 25.5 28.375Z",
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7539 35.1562C14.9442 33.0942 16.6563 31.3818 18.7182 30.1912C20.7801 29.0007 23.1191 28.3739 25.5 28.3739C27.8809 28.3739 30.2199 29.0007 32.2818 30.1912C34.3437 31.3818 36.0558 33.0942 37.2461 35.1562",
    stroke: "currentColor",
    strokeWidth: 1.9375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.23c2a498ff08462632722e93b7fd8851.svg";
export { ForwardRef as ReactComponent };